// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1k227","title":"Header_title__120iZ","side":"Header_side__3mQIp"};